var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _c(
            "div",
            { staticClass: "row justify-end q-mb-sm-none q-mb-md" },
            [
              _c("q-select", {
                staticClass: "project__mode-dropdown",
                attrs: {
                  "hide-underline": "",
                  "inverted-light": "",
                  color: "white",
                  options: _vm.typeFilterOptions,
                  value: _vm.typeFilter
                },
                on: { change: _vm.handleTypeFilterChanged }
              })
            ],
            1
          ),
          _vm.projects.length || _vm.isTemporaryResult
            ? [
                _c(
                  "q-infinite-scroll",
                  {
                    ref: "infiniteScroll",
                    attrs: { handler: _vm.handleFetchNextChunk }
                  },
                  _vm._l(_vm.groupedProjects, function(group, index) {
                    return _c("div", { key: index, staticClass: "q-mb-xl" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "q-headline text-bold text-blue-grey-4 q-mb-sm"
                        },
                        [_vm._v(_vm._s(group.group))]
                      ),
                      _c(
                        "div",
                        { staticClass: "row gutter-md" },
                        _vm._l(group.values, function(project) {
                          return _c(
                            "div",
                            {
                              key: project.id,
                              staticClass: "col-xs-12 col-md-6 col-xl-4"
                            },
                            [
                              _c("project-card", {
                                attrs: { project: project }
                              })
                            ],
                            1
                          )
                        })
                      )
                    ])
                  })
                )
              ]
            : _vm._e(),
          _vm.showEmptyState
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-pt-lg"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("assets/emptystates/projects_empty.svg")
                          }
                        }),
                        _c("h6", { staticClass: "q-my-md text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("projects_empty")))
                        ]),
                        _c(
                          "q-btn",
                          {
                            staticClass: "q-mt-lg",
                            attrs: { color: "primary", outline: "" },
                            on: { click: _vm.handleCreateProject }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("create_project")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "q-page-sticky",
        { attrs: { position: "bottom-right", offset: [18, 18] } },
        [
          _c(
            "q-btn",
            {
              directives: [{ name: "is-user", rawName: "v-is-user" }],
              attrs: { color: "primary", round: "", fab: "" },
              on: { click: _vm.handleCreateProject }
            },
            [_c("q-icon", { attrs: { name: "add" } })],
            1
          )
        ],
        1
      ),
      _c("project-modal", {
        ref: "createProjectModal",
        on: { save: _vm.handleSaveProject }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }